import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";

@Component({
    selector: 'app-favorite-no-data',
    templateUrl: './favorite-no-data.component.html',
    styleUrls: [ './favorite-no-data.component.scss' ]
})

export class FavoriteNoDataComponent {
    @Input() backgroundColor: string = '#dad3ea';

    @Input() height: string = '100dvh';

    constructor(private readonly router: Router){}

    goToContact(){
        this.router.navigate(['questions']);
    }
}